<div class="bin-range-container">
  @if (formGroup) {
    <form [formGroup]="formGroup" class="form-container">
      @if (binRangeExclusion?.id) {
        <div class="info">Bin Range #{{ binRangeExclusion?.id }}</div>
      }
      @if (!binRangeExclusion?.id) {
        <div class="info">Create new</div>
      }
      <mat-form-field>
        <mat-label>Payment provider</mat-label>
        <mat-select formControlName="paymentSolutions" multiple>
          @for (paymentSolution of paymentSolutionsList; track paymentSolution) {
            <mat-option [value]="paymentSolution">{{ paymentSolution }}</mat-option>
          }
        </mat-select>
        @if (formGroup.get('paymentSolutions')?.hasError('required')) {
          <mat-error> Field is required </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Bin range</mat-label>
        <input matInput type="number" formControlName="binRange" placeholder="Bin range" />
        @if (formGroup.get('binRange')?.hasError('required')) {
          <mat-error> Field is required </mat-error>
        }
        @if (formGroup.get('binRange')?.hasError('max')) {
          <mat-error> Bin range cannot be longer than 6 digits </mat-error>
        }
      </mat-form-field>
      <div>
        <a (click)="close()">
          <button mat-stroked-button>Cancel</button>
        </a>
        <button class="save-button" mat-raised-button color="primary" [disabled]="!formGroup?.valid" (click)="save()">
          Save
        </button>
      </div>
    </form>
  }
</div>
